<template>
  <div id="map-polygon" />
</template>

<script>
import L from 'leaflet'
import { getMapParent } from '@/utils/utils'

export default {
  name: 'MapPolygon',
  props: {
    bounds: {
      type: Array,
      required: true
    },
    color: {
      type: String
    }
  },
  data () {
    return {
      map: null,
      polygon: null
    }
  },
  watch: {
  },
  created () {
    this.map = getMapParent(this.$parent).map

    this.polygon = L.polygon(this.bounds, {
      color: this.color,
      fill: false
    })
      .addTo(this.map)

    this.$emit('ready', this.map)
  },
  beforeDestroy () {
    this.map.removeLayer(this.polygon)
  },
  methods: {
    onHiddenChange () {
      if (this.hidden) {
        this.map.removeLayer(this.marker)
      } else {
        this.map.addLayer(this.marker)
      }
    }
  }
}
</script>
